import React from "react";
import { ArrowDownIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { CtaButton } from "../CtaButton";
import { pathwaySteps } from "../../data/content";
export function Pathway() {
  return <section className="bg-white px-4 py-16 md:py-24" aria-labelledby="pathway-title" data-id="element-229" data-mp="4cvo8byg68d6">
      <div className="mx-auto max-w-5xl" data-id="element-230" data-mp="9a3vhhi24rzn">
        <SectionHeading eyebrow="A new way to think about sensory integration" title={<span id="pathway-title" data-id="element-232" data-mp="3cs5nlcayczh9">
              “I observed so many things… <em className="text-brand-600" data-id="element-233" data-mp="3csfb8t8iyujs">but how do I connect them?</em>”
            </span>} subtitle="I created the Sensory Decision Map™ for exactly that moment. Instead of another massive course to watch, this system gives you a visual pathway for organizing what you already know." data-id="element-231" data-mp="9d9jsuiv3pub" />

        <div className="mt-12 grid gap-10 md:grid-cols-[1fr_1.1fr] md:items-center md:gap-14" data-id="element-234" data-mp="x3dn10s51nks">
          <div className="text-center md:text-left" data-id="element-235" data-mp="121xbp8y49dgu">
            <p className="text-lg leading-relaxed text-muted" data-id="element-236" data-mp="1c4hnmiepz17e">
              You start with the <strong className="text-ink" data-id="element-237" data-mp="183e49lxgqn1f">child's functional concerns</strong>. Then you move through
              each step — so you don't have to rely on memory alone.
            </p>
            <p className="mt-6 font-serif text-2xl font-extrabold leading-snug text-ink md:text-3xl" data-id="element-238" data-mp="y600omwn1sqj">
              From a therapist who questions every observation… to a professional with a{" "}
              <span className="text-brand-600" data-id="element-239" data-mp="og6q9p88fjnv">clearer process</span> for organizing the case.
            </p>
            <p className="mt-6 rounded-2xl bg-brand-50 p-5 text-base font-semibold text-brand-900" data-id="element-240" data-mp="kdtofbwlw5wd">
              The goal isn't to replace your clinical judgment. It's to give your clinical judgment a structure.
            </p>
          </div>

          <ol className="mx-auto w-full max-w-md" data-id="element-241" data-mp="afdul1672ij6">
            {pathwaySteps.map((step, i) => <li key={step} className="flex flex-col items-center" data-id="element-242" data-mp="5huhi4l8gbst" data-mpi={i}>
                <div className={`flex w-full items-center gap-4 rounded-2xl px-5 py-3.5 ${i === pathwaySteps.length - 1 ? "bg-go text-white" : "bg-brand-900 text-white"}`} data-id="element-243" data-mp="3rxt6wg4uuj0l">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white/15 text-sm font-bold" data-id="element-244" data-mp="3j0iuusk7qpum">
                    {i + 1}
                  </span>
                  <span className="text-[17px] font-bold" data-id="element-245" data-mp="ekq24oyvf1xa">{step}</span>
                </div>
                {i < pathwaySteps.length - 1 && <ArrowDownIcon className="my-1 h-5 w-5 text-brand-500" aria-hidden="true" data-id="element-246" data-mp="5s615hv3wl9a" />}
              </li>)}
          </ol>
        </div>

        <div className="mt-12" data-id="element-247" data-mp="9qva8y943gn4">
          <CtaButton label="I want a clearer reasoning system" data-id="element-248" data-mp="xiagv37x8k46" />
        </div>
      </div>
    </section>;
}